import { useAppStore } from 'hooks/state/useAppStore';
import { useDataRequest } from 'hooks/useDataRequest';
import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';
import { TenantConfigContext } from 'context/TenantConfigContext';
import { BENCHMARKING_FILTER_SET, Service, useDataService } from 'services/data.service';
import { DataResult } from 'models/data';

export const useBenchmarkDataResult = (endpoint: string) => {
  const { benchmark } = useAppStore();

  const { accountNumber } = useContext(TenantConfigContext);
  const requestData = useDataRequest();
  const { fetchData } = useDataService(Service.Benchmarking, BENCHMARKING_FILTER_SET);

  return useQuery({
    retry: 2,
    queryKey: [
      endpoint,
      benchmark,
      accountNumber,
      requestData.filters,
      requestData.benchmarkingTimeFilter,
      requestData.benchmarkingComparisonTimeFilter,
    ],
    queryFn: async (): Promise<DataResult> => {
      const response = await fetchData(endpoint, requestData);
      if (response.error) {
        // Needed as our 'makeApiCall' is not returning standard error response but just an error attribute
        // This assures useQuery sees this as an error and exposes it via it's standard mechanism
        throw Error(response.error.message);
      }
      return response.data!;
    },
    staleTime: 0,
  });
};
